const ChevronsRight = [
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  },
  [
    ["polyline", { points: "13 17 18 12 13 7" }],
    ["polyline", { points: "6 17 11 12 6 7" }]
  ]
];

export default ChevronsRight;
